
import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, Row, Col, DatePicker, Select } from 'antd';
import { formItemLayout } from '../../../util/formItemLayoutConfig';
import moment from 'moment';
import './indexForm.less';

const { RangePicker } = DatePicker;
const currentDay = new Date();
const { Option } = Select;

export const IndexForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    props.searchFn();
  };

  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='search-form-container'>
      <Form
        form={form}
        name="order-form"
        {...formItemLayout}
        onFinish={onFinish}
        initialValues={{
          replenish_time: [moment(currentDay), moment(currentDay).add(7, 'days')],
          result_time: moment(currentDay),
        }}
      >
        <Row>
          <Col span={8}>
            <Form.Item name="goods_name" label='商品名称：' className='search-form-label'>
              <Input placeholder="请输入商品名称关键词" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="goods_code" label='RMS商品编码：' className='search-form-label' >
              <Input placeholder="请输入商品编码" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="replenish_time" label='建议补货时间：' className='search-form-label'>
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="result_time" label='数据更新时间：' className='search-form-label'>
              <DatePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="replenish_type" label='生鲜/干品' className='search-form-label' >
              <Select placeholder='请选择品类'>{[{ name: '生鲜', value: 10 }, { name: '干品', value: 20 }].map(item => <Option key={item.value} value={item.value}>{item.name}</Option>)}</Select>
            </Form.Item>
          </Col>
          {/* <Col span={6}>
            <Form.Item name="replenish_qty_gt" label='补货量筛选：' className='search-form-label'>
              <InputNumber placeholder="请输入补货量筛选" />
            </Form.Item>
          </Col> */}
          <Col offset={6} span={2}>
            <Form.Item wrapperCol={{ span: 24 }}>
              <div className='search-form-btn-container'><Button type='primary' className='search-form-btn' htmlType="submit">查询</Button></div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div >
  );
});
